<template>
    <div id='error'>
        <span class="content">{{message}}</span>
    </div>
</template>

<script>
export default {
    name: 'error',

    computed: {
        message() {
            return this.$route.query.message || '页面加载异常';
        }
    }
}
</script>

<style lang="scss" scoped>
#error {
    height: 100%;
    width: 100%;
    .content {
        font-size: 18px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>